import classNames from 'classnames';
import { parseDate } from '../../../../utilities/helpers';
import { format } from 'date-fns';
import { getDateFnsLocale } from '../../../../utilities/localeUtils';

export default function Months(props) {
  const { months, selectedMonths, onChange, monthAhead } = props;

  const onMonthClick = (month) => {
    const monthInt = parseInt(month);
    const index = selectedMonths.indexOf(monthInt);
    const value =
      index !== -1
        ? [...selectedMonths].filter((item) => item !== monthInt)
        : [...selectedMonths, monthInt];

    onChange(value);
  };

  const isMonthSelected = (item) =>
    selectedMonths?.some(
      (month) => month === parseInt(format(parseDate(months[item].start), 'M'))
    );

  return (
    <>
      <div className="dates-filter__select-month">
        {Object.keys(months).map((item, key) => (
          <div
            key={key}
            className={classNames('month-item', {
              'month-item--selected': isMonthSelected(item),
            })}
            onClick={() =>onMonthClick(format(parseDate(months[item].start), 'M'))}
          >
            <div className="month-item__name">
              {format(parseDate(months[item].start), 'LLL', { locale: getDateFnsLocale() })}{' '}
            </div>
            <div className="month-item__year">{format(parseDate(months[item].start), 'yyyy')}</div>
          </div>
        )).slice(0, monthAhead)}
      </div>
    </>
  );
}
